export default __webpack_public_path__ + "static/media/alumni.75a59c19.webp";